import { render, staticRenderFns } from "./AthleteSelfAssessmentForm.vue?vue&type=template&id=6675652c&scoped=true&"
import script from "./AthleteSelfAssessmentForm.vue?vue&type=script&lang=ts&"
export * from "./AthleteSelfAssessmentForm.vue?vue&type=script&lang=ts&"
import style0 from "./AthleteSelfAssessmentForm.vue?vue&type=style&index=0&id=6675652c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6675652c",
  null
  
)

export default component.exports